import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

export class ColorModel {
  constructor(val: string) {
    this.value = val;
    val = val.substr(1);
    this.r = parseInt(val.substring(0, 2), 16);
    this.g = parseInt(val.substring(2, 4), 16);
    this.b = parseInt(val.substring(4, 6), 16);
  }

  value: string;
  r: number;
  g: number;
  b: number;

  public diff(val: string) {
    while (val.indexOf('#') >= 0)
      val = val.substr(1);
    const r = parseInt(val.substring(0, 2), 16);
    const g = parseInt(val.substring(2, 4), 16);
    const b = parseInt(val.substring(4, 6), 16);
    return Math.abs(r - this.r) +
      Math.abs(g - this.g) +
      Math.abs(b - this.b);
  }
}

@Component({
    selector: 'app-color-selector',
    templateUrl: './color-selector.component.html',
    styleUrls: ['./color-selector.component.css'],
    standalone: false
})
export class ColorSelectorComponent {

  public pickerOpen: boolean = false;

  @Input('colors')
  set onColorsSet(colors: string[]) {
    this.setColors(colors);
  }

  private setColors(colors: string[]) {
    colors.forEach(col => {
      const model = new ColorModel(col);
      this._colors.push(model);
    });
    setTimeout(() => {
    if (colors && colors.length > 0 && (!this.selectedColor || this.selectedColor.length == 0))
      this.selectedColor = colors[0];
    else {
      this.selectedColor = this.findClosest(this.selectedColor).value;
    }
    });
    this.onColorSelected.emit(this.selectedColor);
  }

  public _colors: ColorModel[] = [];

  @Output()
  public onColorSelected: EventEmitter<string> = new EventEmitter<string>();

  @Input('color')
  set onColorSet(color: string) {
    if (!color) this.selectedColor ="#ac725e";
    this.selectedColor = this.findClosest(color).value;
  }

  public selectedColor: string;

  constructor() {
    const defaultColor = "#000000,#ac725e,#d06b64,#f83a22,#fa573c,#ff7537,#ff00ff,#ffad46,#42d692,#16a765,#7bd148,#b3dc6c,#fbe983,#fad165,#92e1c0,#92e1c0,#9fc6e7,#00A2E8,#4986e7,#9a9cff,#b99aff,#c0c0c0";
    this.setColors(defaultColor.split(','));
  }

  private findClosest(color: string): ColorModel {
    if (!color || color.length == 0)
      return this._colors[0];
    let existingColor = this._colors.find(c => c.value == color);
    if (existingColor)
      return existingColor;

    let min = Infinity;
    let result;
    this._colors.forEach(col => {
      if (col.diff(color) < min) {
        min = col.diff(color);
        result = col;
      }
    });
    return result;
  }

  public onSelect(col: ColorModel) {
    this.selectedColor = col.value;
    let result = col.value;
    if (col.value.indexOf('#') < 0)
      result = '#' + result;
    this.onColorSelected.emit(result);
  }

}
